import type { ReactNode } from "react";

/** Renderiza una tecla de atajo. Ej: <Kbd>Ctrl</Kbd> + <Kbd>/</Kbd> */
export default function Kbd({ children }: { children: ReactNode }) {
  return (
    <kbd className="inline-flex min-w-[1.5rem] items-center justify-center rounded border border-ink-600
                    bg-ink-800 px-1.5 py-0.5 font-mono text-[10px] font-medium uppercase text-zinc-300
                    shadow-[inset_0_-1px_0_rgba(0,0,0,0.4)]">
      {children}
    </kbd>
  );
}
